/**
 * Frontile Color Palette
 *
 * Theme-independent color scales.
 */

const gray = {
  '50': '#f8f8f8',
  '100': '#ececec',
  '200': '#dddcdc',
  '300': '#c9c8c7',
  '400': '#b1afad',
  '500': '#94918f',
  '600': '#74706d',
  '700': '#554f4b',
  '800': '#39332e',
  '900': '#241c17',
  '950': '#140b06'
};

const blue = {
  '50': '#f9fcff',
  '100': '#f1f7ff',
  '200': '#d2e6ff',
  '300': '#95c4ff',
  '400': '#4a8ee7',
  '500': '#2259a6',
  '600': '#053273',
  '700': '#001b4e',
  '800': '#000e38',
  '900': '#00072d',
  '950': '#020825'
};

const green = {
  '50': '#f7ffeb',
  '100': '#e6ffbc',
  '200': '#d1ff8c',
  '300': '#bbff60',
  '400': '#a3fa3a',
  '500': '#66e221',
  '600': '#2fc511',
  '700': '#07a20a',
  '800': '#027b1b',
  '900': '#005321',
  '950': '#002e1b'
};

const orange = {
  '50': '#fff3e9',
  '100': '#ffd6b9',
  '200': '#ffb686',
  '300': '#ff914d',
  '400': '#ef7125',
  '500': '#d95503',
  '600': '#bc3e00',
  '700': '#9e2800',
  '800': '#7f1301',
  '900': '#600102',
  '950': '#3e0004'
};

const pink = {
  '50': '#fefafc',
  '100': '#ffebf4',
  '200': '#ffcee4',
  '300': '#fca8cc',
  '400': '#f17bad',
  '500': '#e1458a',
  '600': '#c10566',
  '700': '#920147',
  '800': '#69002d',
  '900': '#4a011c',
  '950': '#390011'
};

const red = {
  '50': '#ffedea',
  '100': '#ffcbc2',
  '200': '#ffa697',
  '300': '#fe7d69',
  '400': '#ff432e',
  '500': '#e51701',
  '600': '#bf1201',
  '700': '#9a0d01',
  '800': '#760700',
  '900': '#550400',
  '950': '#360100'
};

const teal = {
  '50': '#0768731a',
  '100': '#c6f5f4',
  '200': '#7ce0e1',
  '300': '#47c1c7',
  '400': '#26a0aa',
  '500': '#12828e',
  '600': '#076873',
  '700': '#01525c',
  '800': '#003f48',
  '900': '#003138',
  '950': '#00262c'
};

const violet = {
  '50': '#fcfbff',
  '100': '#f0e8ff',
  '200': '#dfd0ff',
  '300': '#c8b6f6',
  '400': '#ac98e7',
  '500': '#8d78d4',
  '600': '#6d55bf',
  '700': '#4f30aa',
  '800': '#370191',
  '900': '#23016a',
  '950': '#170054'
};

const yellow = {
  '50': '#faffe9',
  '100': '#f9ffcc',
  '200': '#fffb12',
  '300': '#faea2b',
  '400': '#eed434',
  '500': '#d9ba34',
  '600': '#be9b2e',
  '700': '#9b7923',
  '800': '#745512',
  '900': '#493001',
  '950': '#1c0e00'
};

export { gray, blue, green, orange, pink, red, teal, violet, yellow };
